/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const Component2 = ({
  className,
  group = "/img/group-3.png",
  vector = "/img/vector-3.png",
  img = "/img/vector-4.png",
  vector1 = "/img/vector-5.png",
  vector2 = "/img/vector-6.png",
  vector3 = "/img/vector-13.png",
  rectangle = "/img/rectangle-82.png",
  vector4 = "/img/vector-7.png",
  vector5 = "/img/vector-8.png",
}) => {
  return (
    <div className={`component-2 ${className}`}>
      <div className="overlap-group-2">
        <img className="group" alt="Group" src={group} />
        <img className="vector-9" alt="Vector" src={vector} />
        <img className="vector-10" alt="Vector" src={img} />
        <img className="vector-11" alt="Vector" src={vector1} />
        <img className="vector-12" alt="Vector" src={vector2} />
        <div className="rectangle-10" />
        <img className="vector-13" alt="Vector" src={vector3} />
        <img className="vector-14" alt="Vector" src="/img/vector-16.png" />
        <img className="rectangle-11" alt="Rectangle" src={rectangle} />
        <div className="text-wrapper-22">+1 (646) 555-7382</div>
        <img className="vector-15" alt="Vector" src={vector4} />
        <div className="text-wrapper-23">Socials</div>
        <img className="vector-16" alt="Vector" src={vector5} />
        <img className="vector-17" alt="Vector" src="/img/vector-14.png" />
      </div>
    </div>
  );
};

Component2.propTypes = {
  group: PropTypes.string,
  vector: PropTypes.string,
  img: PropTypes.string,
  vector1: PropTypes.string,
  vector2: PropTypes.string,
  vector3: PropTypes.string,
  rectangle: PropTypes.string,
  vector4: PropTypes.string,
  vector5: PropTypes.string,
};
